export enum EModalConfirmationTypes {
  PAUSE_OR_CLOSE = "PAUSE_OR_CLOSE",
  RESET = "RESET",
  EXAM_EDIT_IN_PROGRESS = "EXAM_EDIT_IN_PROGRESS"
}

export interface IVetExamState {
  modalState: boolean;
  modalType: EModalConfirmationTypes;
  isExamFormOpen: boolean;
  isEditPastExamFormOpen: boolean;
  currentPastExamId: string;
  isUseLastExamEntry: boolean;
}
